import React, { memo, ReactElement } from "react";

export interface InfoIconProps {
    className?: string;
    size?: number;
}

function InfoIcon(props: InfoIconProps): ReactElement {
    const { size = 13, className } = props;

    return (
        <div className={className}>
            <svg
                width={size}
                height={size}
                viewBox="0 0 13 13"
                fill="#787A86"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    clipRule="evenodd"
                    d="M6.5 12a5.5 5.5 0 100-11 5.5 5.5 0 000 11z"
                    stroke="#787A86"
                    strokeWidth={0.825}
                />
                <path
                    d="M5.807 9.415v.055h1.38V5.73h-1.38v3.685zm.69-4.433a.777.777 0 00.781-.781.777.777 0 00-.78-.781.777.777 0 00-.782.781c0 .435.347.781.781.781z"
                    fill="#FFF"
                    stroke="#FFF"
                    strokeWidth={0.11}
                />
            </svg>
        </div>
    );
}

export default memo(InfoIcon);
